var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var YesNoConfirmationModal = require('../common/yes-no-confirmation-modal');
var CommonUtils = require('../../utils/common-utils.js');

var utils = new CommonUtils();

var Radio = require('backbone.radio');
var actionsChannel = Radio.channel('actions');
var notificationsChannel = Radio.channel('notifications');

var PermissionRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/permissions/permission-row.html'),
    events: {
        'click .pemission-delete': 'removePermission',
        'click input[type=checkbox]': 'onChecked'
    },

    templateContext: function () {
        var that = this;
        var owner = that.model.get('owner');
        var org = that.model.get('organization');
        return {
            owner: owner == undefined ? '-' : utils.formatPerson(owner.object)
                + (!owner.object || _.isEmpty(owner.object.npi) || _.isUndefined(owner.object.npi) ? '' : ' (' + owner.object.npi + ')'),
            ownerId: owner == undefined ? '' : owner.object.login,
            showOrganization: that.showOrganization,
            organization: org == undefined ? '-' : org.name
                + (!org.object || _.isEmpty(org.object.npi) || _.isUndefined(org.object.npi) ? '' : ' (' + org.object.npi + ')'),
            organizationId: org == undefined ? '' : org.id,
            permittedObjectType: that.permittedObjectType
        }
    },

    initialize: function (options) {
        _.bindAll(this, 'removePermission', 'onChecked');
        this.showOrganization = options.showOrganization
        this.permittedObjectType = options.permittedObjectType;
    },

    removePermission: function (event) {
        this.triggerMethod('delete:model', this.model);
    },

    onChecked: function (event) {
        this.model.set(event.target.value, event.target.checked);
        this.triggerMethod('update:model', this.model);
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(13), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PermissionsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PermissionRowView,
    emptyView: EmptyView,

    collectionEvents: {
        request: 'showLoading',
        sync: 'hideLoading',
        error: 'logError'
    },

    childViewEvents: {
        'update:model': 'updateModel',
        'delete:model': 'deleteModel'
    },

    initialize: function (options) {
        _.bindAll(this, 'showLoading', 'hideLoading', 'logError', 'updateModel', 'deleteModel');
        this.showOrganization = options.showOrganization;
        this.permittedObjectType = options.permittedObjectType;
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {
            showOrganization: this.showOrganization,
            permittedObjectType: this.permittedObjectType
        };
    },

    showLoading: function () {
        this.$('.loading').show();
    },

    hideLoading: function () {
        this.$('.loading').hide();
    },

    logError: function (obj, response) {
        this.$('.loading').hide();
        this.triggerMethod('server:error', response.responseText);
    },

    updateModel: function (model) {
        var that = this;
        var callback = function () {
            var cloned = model.clone();
            cloned.unset('owner');
            cloned.unset('organization');
            cloned.save();
            that.render();
        };
        this.triggerMethod('on:action', callback);
    },

    deleteModel: function (model) {
        var that = this;
        var responseHandler = function (model, xhr, options) {
            if (xhr.status == 200) {
                that.collection.remove(model);
                that.render();
            }
            else
                notificationsChannel.request('show:notification', JSON.parse(xhr.responseText));
        };
        var callback = function () {
            model.destroy({
                wait: true,
                success: responseHandler,
                error: responseHandler
            });
        }
        this.triggerMethod('on:action', callback);
    }
});

var PermissionsTableView = Marionette.View.extend({
    tagName: 'div',
    className: 'permissions-table',
    template: require('../../templates/permissions/permissions-table.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        confirmationModal: '#yes-no-confirmation-modal'
    },

    childViewEvents: {
        'action:confirmed': 'saveConfirmed',
        'on:action': 'onAction'
    },

    showOrganization: false,
    callback: undefined,

    templateContext: function () {
        return {
            showOrganization: this.showOrganization,
            permittedObjectType: this.permittedObjectType
        }
    },

    onRender: function () {
        var that = this;
        that.collection.fetch({
            success: function () {
                that.showChildView('body', new PermissionsTableBody({
                    collection: that.collection,
                    showOrganization: that.showOrganization,
                    permittedObjectType: that.permittedObjectType
                }));
            },
            error: function (collection, response, options) {
                if (response.status == 401) {
                    actionsChannel.request("redirect:to:login");
                }
            }
        });

        that.showChildView('confirmationModal', new YesNoConfirmationModal({message: 'You will update permission. Are you sure?'}));
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(that, 'saveConfirmed', 'onAction');
        if (options.showOrganization != undefined)
            that.showOrganization = options.showOrganization;
        that.permittedObjectType = options.permittedObjectType;
        that.collection = options.collection;
    },

    onAction: function (callback) {
        this.callback = callback;
        if (typeof callback !== "function")
            return;
        this.$('#confirmation-modal').modal();
    },

    saveConfirmed: function (data) {
        if (data.result == true) {
            this.callback();
        }
        else {
            this.$('#confirmation-modal').modal('hide');
        }
    }
});

module.exports = PermissionsTableView;


//////////////////
// WEBPACK FOOTER
// ./app/views/permissions/permissions-table-view.js
// module id = 236
// module chunks = 0